/**
 * @generated SignedSource<<19254404baeb9f9d594c56b629b3aada>>
 * @relayHash e40f4f53f0d4c1a58f8b31362b65e5fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cbcd85aecff178dd8c53a23e74d555420b80c11e578098e83544518bffe7a19

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9cbcd85aecff178dd8c53a23e74d555420b80c11e578098e83544518bffe7a19",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
